<div>
  <form #profileForm="ngForm" (ngSubmit)="onSubmit(profileForm.value)">
    <div class="card card-secondary">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="card-title w-100">
          <span>Profile Settings For: {{profile.emailAddress}}</span>
        </h4>
        <!--<a (click)="unlinkAgent()" class="btn btn-dark rounded-pill btn-sm" ngbTooltip="Unlink Your Agent IDs" tooltipClass="lbig-tooltip">Unlink&nbsp;IDs</a>-->
      </div>

      <div class="card-body box-profile">
        <div class="text-right">
          <input type="button" class="btn btn-secondary input-block-level" value="Unlink Your Agent IDs" (click)="unlinkAgent()">
        </div>
        <div class="form-group">
          <label>My Linked Agent IDs</label>
          <app-agentgrid></app-agentgrid>
        </div>
        <!--<div class="form-group">
    <label>Display Name</label>
    <input class="form-control" name="displayName" [(ngModel)]="displayName" [value]="displayName">
  </div>-->
      </div>
      <div class="card-footer">
        <div class="text-center">
          <input type="submit" class="btn btn-secondary input-block-level" value="Save Changes">
        </div>
      </div>
    </div>
  </form>
</div>
